<script setup lang="ts">
    import { componentStyle } from '@/styling/util/component-style';
    import type { ButtonDesignTokens } from '@primeuix/themes/types/button';
    import Button, { type ButtonProps } from 'primevue/button';

    // needed as primevue does not properly forward types for the button component,
    // and we want to be able to use it in the same way as a normal primevue button,
    // but with our own styling for the supplier portal

    // eslint-disable-next-line vue/prop-name-casing
    defineProps</* @vue-ignore */ Partial<ButtonProps>>();

    const designTokens = componentStyle<ButtonDesignTokens>({
        root: {
            borderRadius: '6px',
        },
    });
</script>
<template>
    <Button class="spp-button" :dt="designTokens" v-bind="$attrs" />
</template>
<style scoped lang="scss">
    @use '@/styling/main';

    .spp-button {
        height: 48px;
    }
</style>
